import React from 'react';
import ReactDOM from "react-dom";

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    filters: {
        serviceType: string;
        workType: string;
        carePlaceType: string;
        startDate: string;
        location: string;
        gender: string;
        order: string;
    }
    onFilterChange: (filters: any) => void;
    onFilterApply: () => void;
    onFilterReset: () => void;
}

const FilterModal: React.FC<FilterModalProps> = ({
                                                     isOpen,
                                                     onClose,
                                                     filters,
                                                     onFilterChange,
                                                     onFilterApply,
                                                     onFilterReset
                                                 }) => {
    const modalRoot = document.getElementById("modal-root");

    React.useEffect(() => {
        if (isOpen) {
            document.body.classList.add("modal-open");
        }
        return () => document.body.classList.remove("modal-open");
    }, [isOpen]);

    if (!isOpen || !modalRoot) return null;

    const handleChange = (field: string, value: string) => {
        onFilterChange({...filters, [field]: value});
    };

    return ReactDOM.createPortal(
        <div className="modal" style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}} onClick={onClose}>
            <div className="modal-dialog ver4" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{backgroundColor: 'white'}}>
                    <div className="modal-header">
                        <h3>상세 조건 검색</h3>
                        <button type="button" className="close" onClick={onClose}>
                            ×
                        </button>
                    </div>
                    <div className="modal-body">
                        <form className="form-box modal-form">
                            <div className="form-item">
                                <label className="input-tit">서비스 구분</label>
                                <div className="radio-row">
                <span className="text-radio">
                    <input
                        type="radio"
                        id="serviceType1"
                        name="serviceType"
                        value=""
                        checked={filters.serviceType === ''}
                        onChange={(e) => handleChange('serviceType', e.target.value)}
                    />
                    <label htmlFor="serviceType1">전체</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="serviceType2"
                        name="serviceType"
                        value="CARE"
                        checked={filters.serviceType === 'CARE'}
                        onChange={(e) => handleChange('serviceType', e.target.value)}
                    />
                    <label htmlFor="serviceType2">간병인 신청</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="serviceType3"
                        name="serviceType"
                        value="ESCORT"
                        checked={filters.serviceType === 'ESCORT'}
                        onChange={(e) => handleChange('serviceType', e.target.value)}
                    />
                    <label htmlFor="serviceType3">병원동행 신청</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="serviceType4"
                        name="serviceType"
                        value="HOUSEWORK"
                        checked={filters.serviceType === 'HOUSEWORK'}
                        onChange={(e) => handleChange('serviceType', e.target.value)}
                    />
                    <label htmlFor="serviceType4">가사돌봄 신청</label>
                </span>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">근무 유형</label>
                                <div className="radio-row">
                <span className="text-radio">
                    <input
                        type="radio"
                        id="workType1"
                        name="workType"
                        value=""
                        checked={filters.workType === ''}
                        onChange={(e) => handleChange('workType', e.target.value)}
                    />
                    <label htmlFor="workType1">모두</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="workType2"
                        name="workType"
                        value="DAILY"
                        checked={filters.workType === 'DAILY'}
                        onChange={(e) => handleChange('workType', e.target.value)}
                    />
                    <label htmlFor="workType2">종일제</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="workType3"
                        name="workType"
                        value="HOURLY"
                        checked={filters.workType === 'HOURLY'}
                        onChange={(e) => handleChange('workType', e.target.value)}
                    />
                    <label htmlFor="workType3">시간제</label>
                </span>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">돌봄 장소</label>
                                <div className="radio-row">
                <span className="text-radio">
                    <input
                        type="radio"
                        id="carePlaceType1"
                        name="carePlaceType"
                        value=""
                        checked={filters.carePlaceType === ''}
                        onChange={(e) => handleChange('carePlaceType', e.target.value)}
                    />
                    <label htmlFor="carePlaceType1">모두</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="carePlaceType2"
                        name="carePlaceType"
                        value="HOME"
                        checked={filters.carePlaceType === 'HOME'}
                        onChange={(e) => handleChange('carePlaceType', e.target.value)}
                    />
                    <label htmlFor="carePlaceType2">집</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="carePlaceType3"
                        name="carePlaceType"
                        value="HOSPITAL"
                        checked={filters.carePlaceType === 'HOSPITAL'}
                        onChange={(e) => handleChange('carePlaceType', e.target.value)}
                    />
                    <label htmlFor="carePlaceType3">병원</label>
                </span>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">돌봄 시작일</label>
                                <div className="input-box">
                                    <div className="date-input w100">
                                        <input
                                            type="date"
                                            value={filters.startDate}
                                            onChange={(e) => handleChange('startDate', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">지역</label>
                                <div className="input-box">
                                    <select
                                        value={filters.location}
                                        onChange={(e) => handleChange('location', e.target.value)}
                                    >
                                        <option value="">전체</option>
                                        <option value="서울특별시">서울특별시</option>
                                        <option value="경기도">경기도</option>
                                        <option value="인천광역시">인천광역시</option>
                                        <option value="대전광역시">대전광역시</option>
                                        <option value="세종특별자치시">세종특별자치시</option>
                                        <option value="충청남도">충청남도</option>
                                        <option value="충청북도">충청북도</option>
                                        <option value="광주광역시">광주광역시</option>
                                        <option value="전북특별자치도">전북특별자치도</option>
                                        <option value="전라남도">전라남도</option>
                                        <option value="대구광역시">대구광역시</option>
                                        <option value="경상북도">경상북도</option>
                                        <option value="부산광역시">부산광역시</option>
                                        <option value="울산광역시">울산광역시</option>
                                        <option value="경상남도">경상남도</option>
                                        <option value="강원특별자치도">강원특별자치도</option>
                                        <option value="제주특별자치도">제주특별자치도</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">어르신 성별</label>
                                <div className="radio-row">
                <span className="text-radio">
                    <input
                        type="radio"
                        id="gender1"
                        name="gender"
                        value=""
                        checked={filters.gender === ''}
                        onChange={(e) => handleChange('gender', e.target.value)}
                    />
                    <label htmlFor="gender1">모두</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="gender2"
                        name="gender"
                        value="M"
                        checked={filters.gender === 'M'}
                        onChange={(e) => handleChange('gender', e.target.value)}
                    />
                    <label htmlFor="gender2">남성</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="gender3"
                        name="gender"
                        value="F"
                        checked={filters.gender === 'F'}
                        onChange={(e) => handleChange('gender', e.target.value)}
                    />
                    <label htmlFor="gender3">여성</label>
                </span>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">정렬 순서</label>
                                <div className="radio-row">
                <span className="text-radio">
                    <input
                        type="radio"
                        id="order1"
                        name="order"
                        value="recent"
                        checked={filters.order === 'recent'}
                        onChange={(e) => handleChange('order', e.target.value)}
                    />
                    <label htmlFor="order1">최신순</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="order2"
                        name="order"
                        value="deadline"
                        checked={filters.order === 'deadline'}
                        onChange={(e) => handleChange('order', e.target.value)}
                    />
                    <label htmlFor="order2">마감 임박</label>
                </span>
                                    <span className="text-radio">
                    <input
                        type="radio"
                        id="order3"
                        name="order"
                        value="salary"
                        checked={filters.order === 'salary'}
                        onChange={(e) => handleChange('order', e.target.value)}
                    />
                    <label htmlFor="order3">급여순</label>
                </span>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <div className="modal_btn">
                            <button type="button" className="btn cancle" onClick={onFilterReset}>초기화</button>
                            <button type="button" className="btn confirm" onClick={onFilterApply}>검색하기</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        modalRoot
    );
};

export default FilterModal;